export default {
  getIsUserGuideActive(state) {
    return state.isUserGuideActive;
  },
  getStep(state) {
    return state.step;
  },
};
